import React from 'react'
import ReactDOM from 'react-dom';
import SingleQuoteForm from "../components/quote-form/SingleQuoteForm";

const containers = document.querySelectorAll('.js-quote-form-container')

containers.forEach(container => {
  const { props } = container.dataset
  document.addEventListener('DOMContentLoaded', () => {
    ReactDOM.render(<SingleQuoteForm {...JSON.parse(props)} />, container)
  })
})
